import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// ng2-pdf-viewer defaults to loading its PDF.js worker from cdn.jsdelivr.net,
// which is unreachable from this network — serve it locally instead.
// Served as .js (not .mjs) because pdfjs-dist always instantiates it via
// `new Worker(url, { type: 'module' })` regardless of extension, and many
// web servers don't have a MIME mapping for .mjs, causing browsers to reject
// it as "application/octet-stream" instead of a valid module script.
(window as any).pdfWorkerSrc = 'assets/pdfjs/pdf.worker.min.js';

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
